import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel, FieldError } from '@/components/ui/field';
import { useTranslation } from 'react-i18next';

export const FORM_USER_PASSWORD_EDIT_ID = 'form-user-password-edit';

const initialState = {
    old_password: '',
    new_password: '',
    confirm_password: '',
};

export default function FormUserPasswordEdit({ onSubmit, onReset }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState(initialState);

    useEffect(() => {
        if (onReset) {
            setFormData(initialState);
        }
    }, [onReset]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.old_password || !formData.new_password || !formData.confirm_password) return;
        if (formData.new_password !== formData.confirm_password) return;
        onSubmit(formData);
    };

    return (
        <form
            id={FORM_USER_PASSWORD_EDIT_ID}
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto px-6 py-4 space-y-5"
        >
            <Field>
                <FieldLabel required>{t('account:ancienMotDePasse')}</FieldLabel>
                <Input
                    type="password"
                    value={formData.old_password}
                    onChange={(e) => setFormData((p) => ({ ...p, old_password: e.target.value }))}
                    required
                />
            </Field>

            <Field>
                <FieldLabel required>{t('account:nouveauMotDePasse')}</FieldLabel>
                <Input
                    type="password"
                    value={formData.new_password}
                    onChange={(e) => setFormData((p) => ({ ...p, new_password: e.target.value }))}
                    required
                />
            </Field>

            <Field>
                <FieldLabel required>{t('account:confirmerLeNouveauMotDePasse')}</FieldLabel>
                <Input
                    type="password"
                    value={formData.confirm_password}
                    onChange={(e) => setFormData((p) => ({ ...p, confirm_password: e.target.value }))}
                    required
                />
            </Field>

            {formData.new_password &&
            formData.confirm_password &&
            formData.new_password !== formData.confirm_password ? (
                <FieldError className="text-xs font-semibold">{t('account:lesMotsDePasseNeCorrespondentPas')}</FieldError>
            ) : null}
        </form>
    );
}
